import React, {Component}   from 'react';
import PropTypes            from 'prop-types';
import SummaryField         from '../SummaryField';
import SummaryWidgetEntity  from '../Fragments/SummaryWidgetEntity';

let Quote =  require('../Managers/Quote');

class TenantRow extends Component {
    constructor(props) {
        super(props);
        this.state = {
            tenant: Quote.getChunk('BaseIndividualApplication_' + this.props.currentNumber),
            isLastTenant: false,
        };
    }

    /**
     * onBlur, if the value is blank, reset it to 0
     *
     * @param e
     */
    setActiveValue(e) {
        if (!e > 0) {
            e = 0;
        }

        // call the parent rent share func, and then update the text field
        // in the correct tenant section with the new amount
        new Promise((resolve) => {
            if (this.props.updateTenantRentShare) {
                this.props.updateTenantRentShare(this);
            }
            resolve(true);
        }).then(() => {
            try {
                document.getElementById('rentShare_' + this.props.currentNumber).value = e;
            } catch(err) { /* this can silently fail */ }
        });
    }

    removeTenant(e) {
        e.preventDefault();
        this.props.removeTenant(this.props.currentNumber);
    }

    render() {
        let numberAsString = ['','one','two','three','four','five','six','seven','eight','nine','ten'];
        return(
            <div className="summary-widget">
                <section className="pod">
                    <header className="header">
                        <h3>
                            {this.state.tenant.firstName && this.state.tenant.lastName ? this.state.tenant.firstName + ' ' + this.state.tenant.lastName : 'Tenant ' + numberAsString[this.props.currentNumber] }
                            <a className="underline primary-colour pull-right remove-link" href="#" onClick={this.removeTenant.bind(this)}>Remove</a>
                        </h3>
                    </header>
                    <div className="content">
                        <SummaryWidgetEntity
                            fieldName={'tenant' + this.props.currentNumber + 'RentShare'}
                            localStorageChunk={'BaseIndividualApplication_' + this.props.currentNumber}
                            localStorageKey="rentShare"
                            fieldType="money"
                            label="Share of rent"
                            callbackFunction={this.setActiveValue.bind(this)}
                        />

                        {this.state.tenant.email ?
                            <SummaryWidgetEntity
                                fieldName={'tenant' + this.props.currentNumber + 'Email'}
                                localStorageChunk={'BaseIndividualApplication_' + this.props.currentNumber}
                                localStorageKey="email"
                                fieldType="email"
                                label="Email"
                                callbackFunction={this.setActiveValue.bind(this)}
                            />
                        : null}
                    </div>
                    <footer className="footer">
                        <SummaryField
                            fieldName={'completionMethod_' + this.props.currentNumber}
                            type="radio-group"
                            question="Completion method"
                            options={[
                                {
                                    value: 3,
                                    text: 'Email to tenant'
                                },
                                {
                                    value: 1,
                                    text: 'Complete manually'
                                }
                            ]}
                            storageKey={'completionMethod'}
                            source={'BaseIndividualApplication_' + this.props.currentNumber}
                            loadValues={true}
                            loadingKey={'BaseIndividualApplication_' + this.props.currentNumber + '.completionMethod'}
                        />
                    </footer>
                </section>
            </div>
        );
    }
}

TenantRow.propTypes = {
    tenant:                 PropTypes.object,
    rentAmountOnBlur:       PropTypes.func,
    removeTenant:           PropTypes.func,
    currentNumber:          PropTypes.number.isRequired,
    updateTenantRentShare:  PropTypes.func,
    defaultShare:           PropTypes.number.isRequired,
    fieldName:              PropTypes.string.isRequired,
    inputMask:              PropTypes.string,
    source:                 PropTypes.string,
};

TenantRow.defaultProps = {
    currentNumber: 1,
};

export default TenantRow;


// WEBPACK FOOTER //
// ./src/components/Fragments/TenantRow.js